import React from 'react';
import Slider from 'react-slick/lib/slider';
import useIsMobile from '../Hooks/useIsMobile';
import FooterUspItem from './FooterUspItem';

const FooterUspSlider = ({ uspItems }) => {
  const isMobile = useIsMobile();
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    nextArrow: <></>,
    prevArrow: <></>,
  };
  return (
    <div className="row">
      {isMobile ? (
        <div className="columns small-12">
          <Slider {...settings}>
            {uspItems.map((item) => (
              <FooterUspItem key={item.footerUspText} item={item} />
            ))}
          </Slider>
        </div>
      ) : (
        <div className="[ footer-usps__wrapper ] [ columns small-12 ]">
          {uspItems.map((item, index) => (
            <FooterUspItem key={item.footerUspText + index} item={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default FooterUspSlider;
